// Shared between MetricsTable.js and CustomMetricModal.js — pulled into its own module rather
// than one importing it from the other (that circular import crashed the whole app on load:
// "Cannot access '<minified name>' before initialization", since App.js's top-level import of
// MetricsTable pulled in CustomMetricModal, which pulled METRIC_CATALOG back from MetricsTable
// before that binding was initialized).
// `aggregate` only matters when MetricsTable.js combines several selected drills into one row
// per player: 'sum' (default, omitted below) for cumulative load metrics, 'avg' for
// instantaneous/rate readings, 'max' for peak readings. Time-in-zone (isTime) columns are always
// summed regardless of this flag, since they're cumulative durations.
export const METRIC_CATALOG = [
  { key: 'td',                label: 'Total Distance',                 unit: 'm' },
  { key: 'rd',                label: 'Run Dist. >14.4km/h',             unit: 'm' },
  { key: 'hid',                label: 'HID >19.8km/h',                  unit: 'm' },
  { key: 'sd',                label: 'Sprint Distance >25.2km/h',       unit: 'm' },
  { key: 'sa',                label: 'Short Actions',                  unit: '' },
  { key: 'expl',              label: 'Explosive Distance',             unit: 'm' },
  { key: 'hmld',              label: 'HMLD',                           unit: 'm' },
  { key: 'maxSpeed',          label: 'Max Speed',                      unit: 'km/h', digits: 1, aggregate: 'max' },
  { key: 'minutesPlayed',     label: 'Minutes',                        unit: 'min' },
  // Recomputed from combined Total Distance / Minutes when combining drills (see
  // MetricsTable.js's aggregateGroupRows) rather than averaged like the other 'avg' metrics —
  // averaging per-drill rates would misweight a short drill the same as a long one.
  { key: 'distPerMin',        label: 'Distance / Min',                 unit: 'm/min', digits: 1, aggregate: 'avg' },
  // Labels below are user-specified (2026-09-03) and deliberately don't match the raw field
  // names — "entries" in the CSV maps to "Runs"/"Sprints" in this app's vocabulary.
  { key: 'entriesZone56',     label: 'High Intensity Runs >19,8km/h',  unit: '' },
  { key: 'entriesZone6',      label: 'Sprints >25,2km/h',              unit: '' },
  { key: 'avgHr',             label: 'Average Heart Rate',             unit: 'bpm', aggregate: 'avg' },
  { key: 'maxHr',             label: 'Max Heart Rate',                 unit: 'bpm', aggregate: 'max' },
  { key: 'avgMetabolicPower', label: 'Avg Metabolic Power',            unit: 'W/kg', digits: 1, aggregate: 'avg' },
  { key: 'hrv',                label: 'Heart Rate Variability',        unit: 'ms', aggregate: 'avg' },
  { key: 'modTrimp',          label: 'modTrimp',                       unit: '' },
  { key: 'hrZ1', label: 'HR Zone 1 Time', unit: '', isTime: true },
  { key: 'hrZ2', label: 'HR Zone 2 Time', unit: '', isTime: true },
  { key: 'hrZ3', label: 'HR Zone 3 Time', unit: '', isTime: true },
  { key: 'hrZ4', label: 'HR Zone 4 Time', unit: '', isTime: true },
  { key: 'hrZ5', label: 'HR Zone 5 Time', unit: '', isTime: true },
  { key: 'hrZ6', label: 'HR Zone 6 Time', unit: '', isTime: true },
];

export function evalCustomMetric(row, cm) {
  const a = Number(row[cm.metric_a]);
  const b = cm.metric_b_type === 'constant' ? Number(cm.metric_b) : Number(row[cm.metric_b]);
  if (!isFinite(a) || !isFinite(b)) return null;
  switch (cm.op) {
    case 'add':      return a + b;
    case 'subtract': return a - b;
    case 'multiply': return a * b;
    case 'divide':   return b === 0 ? null : a / b;
    default:         return null;
  }
}
